export default {
	addPerson: "Agregar Persona",
	editPerson: "Editar Persona",
	person: "Persona",
	confirmRemovePerson: "¿Está seguro de que desea eliminar esta persona?",
	errorLoadingPersons: "Error al cargar personas",
	errorLoadingAvailablePersons: "Error al cargar personas disponibles",
	errorSavingPerson: "Error al guardar persona",
	errorDeactivatingPerson: "Error al desactivar persona",
	errorActivatingPerson: "Error al activar persona",
	errorRemovingPerson: "Error al eliminar persona",
	personUpdatedSuccess: "Persona actualizada con éxito",
	personAddedSuccess: "Persona agregada con éxito",
	personDeactivatedSuccess: "Persona desactivada con éxito",
	personActivatedSuccess: "Persona activada con éxito",
	personRemovedSuccess: "Persona eliminada con éxito",
};
